/**
 * author: Ananthapadmanabhan V K
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './SupplierCompanyScore.scss';
import { withTranslation } from 'react-i18next';
import { Badge, Button, Form, Modal, OverlayTrigger, Table } from 'react-bootstrap';
import { BiDownload, BiMenuAltRight, BiPencil, BiSearch, BiShareAlt, BiSort, BiPlus, BiTrash } from 'react-icons/bi';
import { Link } from 'react-router-dom';
import nodataimg from '../../../images/nodatafound.png';
import Pagination from "../../../components/Pagination/Pagination";
import { DEFAULT_ITEMS_PER_PAGE, LIST_DEF_SORT, SORT_ORDER_DESC } from '../../../core/constants/common';
import Utils from '../../../core/utilities/Utils';
import CompanyService from '../../../core/service/CompanyService';
import ErrorHandlingService from '../../../core/service/ErrorHandlingService';
import CountryScoreService from '../../../core/service/CountryScoreService';
import UtilsService from '../../../core/service/UtilsService';
import { Typeahead } from 'react-bootstrap-typeahead';
import { toast } from "react-toastify";
import ConfirmDialog from '../../../core/utilities/ConfirmPopup';
import { FcFinePrint } from "react-icons/fc";

const SupplierCompanyScore = ({ t }) => {
  var data = JSON.parse(localStorage.getItem("authority"));
  const companyId = data.profile.company.id;
  const [key, setKey] = useState("");
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [maintabledata, setMainTableData] = useState([]);
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [regulations, setRegulations] = useState([]);
  const [regulationId, setRegulationId] = useState("");
  const [regulationsubmitid, setRegulationSubmitId] = useState("");
  const [countryData, setCountryData] = useState([]);
  const [countrychoosed, setCountryChoosed] = useState('');
  const [editscorevalue, setEditScoreValue] = useState('');
  const [show, setShow] = useState(false);
  const [editid, setEditId] = useState(null);
  const [countryselectpreset, setCountrySelectPreset] = useState([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteid, setDeleteId] = useState('');
  const [encodeformain, setEncodeForMain] = useState(null);
  useEffect(() => {
    getSubscriptions();
    getCountry();
  }, []);

  const getCountry = () => {
    UtilsService.getCountryList()
      .then((response) => {
        setCountryData([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
      });
  };

  const getSubscriptions = async (e) => {
    if (companyId) {
      CompanyService.getCompanySubscriptions(companyId)
        .then((response) => {
          var resRegulations = response.data.regulations;
          setRegulations([...resRegulations]);
        })
        .catch((error) => {
          //ErrorHandlingService.handleError(error.response.status);
          console.log("err", error);
        });
    }
  };

  const handleRegulationChange = (e) => {
    if (e.target.value != 0) {
      setRegulationId(e.target.value);
      getMainTableList(0, itemsPerPage, key, e.target.value);
    } else {
      setRegulationId(0);
      setMainTableData([]);
    }
  };

  const handleRegulationPopupChange = (e) => {
    setRegulationSubmitId(e.target.value);
  };

  const getMainTableList = (pageNumber, itemsPerPageVal, key, regulationIdValue) => {
    var string = Utils.generateUrlParamCompanyRegulation(companyId, regulationIdValue);
    var encodedDat = Utils.encodeBase64(string);
    setEncodeForMain(encodedDat);
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }
    CountryScoreService.getList(pageNumber, perPage, key, encodedDat)
      .then((response) => {
        var totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
        setMainTableData([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        console.log("err", error);
      });
  };

  const editData = (item) => {
    setEditId(item.id);
    setEditScoreValue(item.score);
    var obj = [
      {
        id: item.country.id,
        code: item.country.code,
        name: item.country.name,
      }
    ]
    setCountrySelectPreset(obj);
    setRegulationSubmitId(regulationId);
    handleShow();
  };
  const handleClose = () => {
    setEditId(null);
    setEditScoreValue('');
    setCountrySelectPreset([]);
    setRegulationSubmitId('');
    setShow(false);
  }

  const deletConfirm = () => {
    CountryScoreService.deleteData(encodeformain, deleteid)
      .then((response) => {
        if (response.status === 200 || response.status === 201 || response.status === 204) {
          toast.success('Success', {
            position: toast.POSITION.TOP_RIGHT,
          });
          getMainTableList(0, itemsPerPage, key, regulationId)
        }
      })
      .catch((error) => {
        console.log('error', error);
        //ErrorHandlingService.handleError(error.response.status);
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }

  const handleSubmit = async (e) => {
    var body = {
      country: {
        id: countrychoosed
      },
      score: editscorevalue
    }
    if (editid) {
      body['id'] = editid;
    }
    var string = Utils.generateUrlParamCompanyRegulation(companyId, regulationsubmitid);
    var encodedDat = Utils.encodeBase64(string);
    // return
    CountryScoreService.onSubmit(encodedDat, body)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          toast.success('Success', {
            position: toast.POSITION.TOP_RIGHT,
          });
          handleClose();
          setRegulationId(regulationsubmitid);
          getMainTableList(0, itemsPerPage, key, regulationsubmitid)
        }
      })
      .catch((error) => {
        console.log('error', error);
        //ErrorHandlingService.handleError(error.response.status);
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });

  }
  const handleShow = () => setShow(true);
  const handleSearch = (e) => {
    var searchKey = e.target.value;
    setKey(searchKey);
    getMainTableList(0, itemsPerPage, searchKey, regulationId);
  };
  return (
    <div className="SupplierCompanyScore">
      <div className="List_header">
        <h5 className="MH">{t("CountryScore.label")}</h5>
        <div className="List_sorts_menu">
          <ul>
            <li>
              <Button variant="secondary">
                <BiDownload /> {t("Import.label")}
              </Button>
            </li>
            <li>
              <Button variant="primary" onClick={handleShow}>
                <BiPlus />
                {t("New.label")}
              </Button>
            </li>
          </ul>
        </div>
      </div>
      <div className="row m-0">
        <div className="col-lg-4 p-2">
          <label className="mb-1">{t("Regulation.label")} <span className='text-red'>*</span></label>
          <select
            value={regulationId}
            className="form-select"
            onChange={handleRegulationChange}
          >
            <option value="" disabled hidden>
              {t("Select.label")}
            </option>
            {regulations?.map((items) => (
              <option value={items.id} key={items.id}>
                {items.name}
              </option>
            ))}
          </select>
        </div>
      </div>


      <div className="List_Table_01">
        <div className="List_table-card01_head">
          <div className="List_table-card_Search_01">
            <div className="List_table-card_Search_Box">
              <Form>
                <input
                  type="text"
                  className="form-control"
                  value={key}
                  onChange={handleSearch}
                />
                <Link to="#" className="Search_iocnBox">
                  <BiSearch />
                </Link>
              </Form>
            </div>
          </div>
          <div className="List_table-card01_sort">
            <ul>
              <li>
                <a href='#'><BiShareAlt /> {t("Share.label")}</a>
              </li>
              <li>
                <a href='#'><BiMenuAltRight /> {t("Sort.label")}</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="card List_table-card01">
          <Table responsive="sm">
            <thead>
              <tr>
                <th>{t("country.label")}</th>
                <th>{t("Score.label")}</th>
                <th>{t("Action.label")}</th>
              </tr>
            </thead>
            {(maintabledata === undefined || maintabledata == null || maintabledata.length === 0) &&
              <tbody>
                <tr>
                  <td colSpan="7" className="text-center">
                    <div className="Nodatafound_box">
                      <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                    </div>
                  </td>
                </tr>
              </tbody>
            }
            {maintabledata && maintabledata !== undefined && maintabledata.length > 0 &&
              <tbody>
                {maintabledata?.map((item) => (
                  <tr key={item.id}>
                    <td>{item.country.name}</td>
                    <td>{item.score}</td>
                    <td>
                      <div className='d-flex'>
                        <div>
                          <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("Edit.label"))}>
                            <span><BiPencil className='cursor' onClick={() => editData(item)} /></span>
                          </OverlayTrigger>
                        </div>
                        <div className='ms-2'>
                          <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("Delete.label"))}>
                            <span><BiTrash className='cursor' onClick={() => {
                              setDeleteId(item.id);
                              setConfirmOpen(true);
                            }} /></span>
                          </OverlayTrigger>
                          <ConfirmDialog
                            title={t("confirmation.label")}
                            open={confirmOpen}
                            setOpen={setConfirmOpen}
                            onConfirm={deletConfirm}                        >
                            <div className='text-center'>{t("ConfirmDelete.label")}</div>
                          </ConfirmDialog>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            }
          </Table>
          <div className="p-2 List_footer_count">
            <Pagination
              itemsTotalCount={itemsTotalCount}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              alwaysShown={true}
              setItemsPerPage={setItemsPerPage}
              pageClicked={(pageNum, perPage) => {
                getMainTableList(pageNum, perPage, key, regulationId);
              }}
            />
          </div>
        </div>
      </div>

      <Modal show={show}
        onHide={handleClose}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Form>
            <div className="Single_RC_01">
              <div className="Single_RC_Row01 m-0">
                <div className="p-2">
                  <label className="mb-1">{t("Regulation.label")} <span className='text-red'>*</span></label>
                  <select
                    value={regulationsubmitid}
                    className="form-select"
                    required
                    onChange={handleRegulationPopupChange}
                  >
                    <option value="" disabled hidden>
                      {t("Select.label")}
                    </option>
                    {regulations?.map((items) => (
                      <option value={items.id} key={items.id}>
                        {items.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="p-2">
                  <label className="mb-1">{t("country.label")} <span className='text-red'>*</span></label>
                  <Typeahead
                    clearButton
                    id="country"
                    onChange={(selected) => {
                      if (selected[0]) {
                        setCountryChoosed(selected[0].id);
                      }
                    }}
                    labelKey={(options) => options.name + '(' + options.code + ')'}
                    options={countryData}
                    defaultSelected={countryselectpreset}
                    inputProps={{ required: true }}
                    placeholder={t("Select.label")}
                  />
                </div>
                <div className="p-2">
                  <label className="mb-1">{t("Score.label")} <span className='text-red'>*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={editscorevalue}
                    required
                    onChange={(e) => setEditScoreValue(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Cancel.label")}
          </Button>
          <Button variant="primary" onClick={handleSubmit} className="sbmBtn">
            {t("Create.label")}
          </Button>

        </Modal.Footer>
      </Modal>
    </div>
  )
};

export default withTranslation()(SupplierCompanyScore);
